<template>
  <div class="mainbox">
    <!-- <img class="logo" :src="require('../assets/logo6.png')" alt="" /> -->
    <div class="head">
      <img class="logo" :src="require('@/assets/logo6.png')" alt="" />
      <div class="name">园长端</div>
    </div>
    <a-form-model :model="form" style="width:400px" layout="vertical">
      <a-form-model-item label="账号" prop="mobile">
        <a-input
          @keydown.enter="submitForm"
          v-model="form.mobile"
          type="text"
          autocomplete="off"
        />
      </a-form-model-item>
      <a-form-model-item label="密码" prop="password">
        <a-input
          @keydown.enter="submitForm"
          v-model="form.password"
          type="password"
          autocomplete="off"
        />
      </a-form-model-item>
      <a-button type="primary" block @click="submitForm()">
        登录
      </a-button>
    </a-form-model>
    <!-- <div @click="wxlogin" class="other">
      <img src="../assets/wx.png" alt="" />
      <div class="name">微信登录</div>
    </div> -->
    <a-modal
      :visible="previewVisible"
      :footer="null"
      centered
      @cancel="previewVisible = false"
      width="360px"
    >
      <div style="padding:20px">
        <img alt="example" style="width: 100%" :src="previewImage" />
        <div class="tip">微信扫一扫登录</div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import qs from "qs";
import Cookies from "js-cookie";
import { directorApi } from "@/api/api-director";
import { EventBus } from "../../utils/eventBus";
export default {
  name: "HelloWorld",
  data() {
    return {
      form: {
        mobile: "",
        password: "",
      },
      previewVisible: false,
      previewImage: require("../../assets/ewm.jpg"),
    };
  },
  created() {
    Cookies.remove("token");
  },
  methods: {
    wxlogin() {
      window.location.href =
        "https://open.weixin.qq.com/connect/qrconnect?appid=wxade2c2629e9c9347&redirect_uri=https://www.guanmini.com/api/Login/scanLogin&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect";
    },
    submitForm() {
      this.$axios({
        method: "POST",
        url: directorApi.domain + directorApi.login,
        headers: { "content-type": "application/x-www-form-urlencoded",Authorization: this.$store.state.headers },
        data: qs.stringify(this.form),
      })
        .then((res) => {
          if (res.data.status != "200") {
            this.$message.error(res.data.msg);
            return false;
          }
          this.$store.dispatch("setUserInfo", res.data.data);
          this.$store.dispatch("setHeader", res.data.token);
          this.$router.push("/director/index");
          const locId = localStorage.getItem("directorId");
          const school = localStorage.getItem("school");
          EventBus.$emit("getFonts", true);
          if (locId == res.data.data.id && school) {
            this.$store.dispatch("setSchool", JSON.parse(school))
          } else {
            this.$store.dispatch("setSchool", res.data.data.schools[0])
            localStorage.setItem("directorId", res.data.data.id);
          }
          this.getUserInfo(res.data.token);
        })
        .catch((e) => {
          console.log(e)
          this.$message.error("登录失败，服务或者网络错误");
        });
    },
    getUserInfo(token) {
      this.$axios({
        method: "POST",
        headers: {
          Authorization: token,
        },
        url: directorApi.domain + directorApi.userInfo,
      })
        .then((res) => {
          if (res.data.status == "200") {
            this.$store.dispatch("setUserInfo", res.data.data);
          }
        })
        .catch(() => {
          this.$message.error("获取园长信息失败，服务或者网络错误");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.tip {
  text-align: center;
  color: #999;
  font-size: 12px;
}
.other {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  color: #898989;
  cursor: pointer;
  img {
    width: 40px;
    height: 40px;
    margin-bottom: 5px;
  }
}
.mainbox {
  width: 1000px;
  height: 600px;
  border-radius: 12px;
  background: #ffffff;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 80px;
  box-sizing: border-box;
}
.logo {
  width: 200px;
  margin-top: 20px;
  margin-bottom: 60px;
}
::v-deep .ant-btn-primary {
  color: #fff;
  background-color: #67b0dc;
  border-color: #67b0dc;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
.head {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  .logo {
    margin-right: 30px;
    margin-top: 10px;
  }
  .name {
    font-size: 30px;
    color: #333;
  }
}
</style>
